<ng-content select='p'></ng-content>
<ng-content select='input[type="checkbox"]'></ng-content>